export const PageToolbar = ({ children, className = "" }) => (
  <div className={`spor-toolbar ${className}`}>{children}</div>
);
